import {
    Route,
    Routes,
    Navigate,
} from "react-router-dom";
import "react-sliding-pane/dist/react-sliding-pane.css";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Admin from "./Admin";
import HrPortal from "./HrPortal";
import SalespersonPortal from "./SalespersonPortal";
import ScrollToTop from "helper/my-com/ScrollToTop";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const App = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                {/* Redirect bare "/" → "/admin/login" so the router always matches */}
                <Route path="/" element={<Navigate to="/admin/login" replace />} />
                <Route path={`/admin/*`} element={<Admin />} />
                <Route path={`/hr/*`} element={<HrPortal />} />
                <Route path={`/salesperson/*`} element={<SalespersonPortal />} />
            </Routes>
            <ToastContainer />
        </>
    );
};

export default App;
